// Файл promise_with_resolvers_polyfill.js

/**
 * Добавляет Promise.withResolvers для браузеров, где API ещё отсутствует.
 * Реализация сохраняет стандартный контракт promise, resolve и reject.
 */

if (typeof Promise.withResolvers !== 'function') {
    Object.defineProperty(Promise, 'withResolvers', {
        configurable: true,
        writable: true,
        value() {
            let resolve;
            let reject;
            const promise = new this((resolve_value, reject_value) => {
                resolve = resolve_value;
                reject = reject_value;
            });

            return {
                promise,
                resolve,
                reject,
            };
        },
    });
}
